import apiClient from "./api";
const HORARIOSENTREGA_API_BASE_URL = "/horariosEntrega";
class HorariosEntregaService {
  getHorariosEntrega() {
    return apiClient.get(HORARIOSENTREGA_API_BASE_URL);
  }
  agregarHorariosEntrega(horarioEntrega) {
    return apiClient.post(HORARIOSENTREGA_API_BASE_URL, horarioEntrega);
  }
  updateHorariosEntrega(horarioEntrega, horarioEntregaId) {
    return apiClient.put(HORARIOSENTREGA_API_BASE_URL + "/" + horarioEntregaId, horarioEntrega);
  }
  deleteHorariosEntrega(horarioEntregaId) {
    return apiClient.delete(HORARIOSENTREGA_API_BASE_URL + "/" + horarioEntregaId);
  }
  async getHorariosEntregaPorSucursal(sucursalId) {
    try {
      const response = await apiClient.get(`${HORARIOSENTREGA_API_BASE_URL}/sucursal/${sucursalId}`,);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new HorariosEntregaService();